import React from 'react';
import WaitCube from '../../../WaitCube.js'
import GpyFileUpload from '../lib/GpyFileUpload.js'
import {_GPY,__GPYPost , __GPYGet,__GPYPostDownload} from '../../../env.js'

class CrewSettings extends React.Component {

	constructor(props) {
			super(props);
			this.state = {
					crews : [],
					crewsIsLoaded:true,
					currentCrew: {id:-1,lastName: "", firstName:"", crewId:"",info:"",email:""},
					unsave:false,
			};
	}


  componentDidMount(){
		this.loadCrew();
	}


	loadCrew(){
		__GPYGet('getCrews',(result)=>{
			this.setState({crewsIsLoaded: true,crews: result.Crews.Crew});
		},(err)=>{
			this.setState({crewsIsLoaded: false});
		});
	}

  onNewCrew(){
				this.setState({currentCrew: {id:-1,lastName: "", firstName:"", crewId:"",info:"",email:""}});
	}

	onSelectCrew(ref){
		ref._lastName = true;
		this.setState( {currentCrew: ref,unsave: false,});
	}

	onChange(e,prop,validator){
		var ref = this.state.currentCrew;
		ref[prop] = e.target.value;

		ref["_"+prop] = false;
		if(validator!==undefined) {
			ref["_"+prop] = validator(ref[prop]);
		}
		console.log(ref);
		this.setState({currentCrew:ref,unsave:true});
	}

	createOrUpdateCrew(){
		__GPYPost('createOrUpdateCrew',this.state.currentCrew,(res)=>{
			this.setState({crewsIsLoaded: true,crews: res.Crews.Crew,unsave:false});
			this.onNewCrew();
		});
	}

	deleteCrew(){
		var ref = this.state.currentCrew;
		ref.del = true;
		__GPYPost('createOrUpdateCrew',ref,(res)=>{
			this.setState({crewsIsLoaded: true,crews: res.Crews.Crew,unsave:false});
			this.onNewCrew();
		});
	}

	onFileUpload(file){
		var ref = this.state.currentCrew;
		ref.profileImage = file;
		this.setState({currentCrew:ref,unsave:true});
	}

	render(){

			return (

			<div>
					<div className="row">
							<div className="col-12 col-lg-3 col-xl-3">

									<div className="row pt-2">
											<div className="col-8"><h3>{_GPY.i18n.get('gametype_SoccerFootball_crew_list_headline')}</h3></div>
											<div className="col-4 text-right align-bottom"><button type="button" onClick={this.onNewCrew.bind(this)} className="btn btn-light btn-sm"><span className="glyphicon glyphicon-plus"/></button></div>
									 </div>

									 <div className="row">
											<div className="col">
												 <div className="list-group">
														{this.state.crewsIsLoaded ? this.state.crews.map((t) =>
															<button key={t.id} onClick={this.onSelectCrew.bind(this,t)} className={t.id === this.state.currentCrew.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
																 <div className="d-flex w-100 justify-content-between">
																	 <small>{t.firstName} {t.lastName}</small>
																	 <img style={{maxWidth : '100px',maxHeight : '25px'}} src={t.profileImage!==undefined&&t.profileImage!==""?_GPY.resource("upload/" + t.profileImage):_GPY.resource("images/default_avatar.png")} className="img-fluid" alt="Avatar"/>
																 </div>
															</button>
														) :  <WaitCube/>  }
												 </div>
											 </div>
									 </div>


							</div>
							<div className="col-12 col-lg-9 col-xl-9 pt-2">


									<h3>{_GPY.i18n.get('gametype_SoccerFootball_crew_headline')}</h3>
									<div className="card bg-light border-success ">
											<div className="card-header">{_GPY.i18n.get('gametype_SoccerFootball_crew_box_headline')}</div>

											<div className="row p-3">
													<div className="col-6">
															<div className="form-group">
																	<label htmlFor="inputTeamName">{_GPY.i18n.get('gametype_SoccerFootball_crew_box_form_input_firstname_title')}</label>
																	<input name="teamName" onChange={(e) => {this.onChange(e,"firstName");}} value={this.state.currentCrew.firstName} type="text" id="inputTeamName" className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_crew_box_form_input_firstname_placeholder')}/>
															</div>
													</div>
													<div className="col-6">
															<div className="form-group">
																	<label htmlFor="inputLastName">{_GPY.i18n.get('gametype_SoccerFootball_crew_box_form_input_lastname_title')}</label>
																	<input name="lastName" onChange={(e) => {this.onChange(e,"lastName",_GPY.isMin2);}} value={this.state.currentCrew.lastName} type="text" id="inputLastName"  className={this.state.currentCrew._lastName?"form-control":"form-control border border-danger"} placeholder={_GPY.i18n.get('gametype_SoccerFootball_crew_box_form_input_lastname_placeholder')}/>
															</div>
													</div>

													<div className="col-12">
															<div className="form-group">
																	<label htmlFor="inputemail">{_GPY.i18n.get('gametype_SoccerFootball_crew_box_form_input_email_title')}</label>
																	<input name="email" onChange={(e) => {this.onChange(e,"email",_GPY.isMin2);} } value={this.state.currentCrew.email!==undefined?this.state.currentCrew.email:""} type="text" id="inputemail"  className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_crew_box_form_input_email_placeholder')}/>
															</div>
													</div>
											</div>

											<div className="row p-3">
													<div className="col-12 col-md-4">

																<div className="row p-0">
																	<div className="col-12">
																		<h5>{_GPY.i18n.get('gametype_SoccerFootball_crew_box_profileimage_headline')}</h5>
															 			<img style={{maxWidth : '100px', maxHeight: '100px'}} src={this.state.currentCrew.profileImage!==undefined&&this.state.currentCrew.profileImage!==""?_GPY.resource("upload/" + this.state.currentCrew.profileImage):_GPY.resource("images/default_avatar.png")} className="img-fluid rounded" alt="Avatar"/>
																	</div>
																	<div className="col-12">
																		<GpyFileUpload fileTypes="jpg,png" className="btn btn-secondary mr-2" callBack={this.onFileUpload.bind(this)}/>
																		{this.state.currentCrew.id>0?
																					<button type="button" className="btn btn-success" onClick={()=>{__GPYPostDownload("getIdCard",{guppyiId:this.state.currentCrew.crewId,fileName:"GuppyiIDCard.pdf"});}}><span className="glyphicon glyphicon-download"/> guppyi IDCard</button>
																					:""}
																	</div>
																</div>

													</div>

													<div className="col-6 col-md-4 text-right">
															<h5>{_GPY.i18n.get('gametype_SoccerFootball_crew_box_guppyiid_headline')}</h5>
															<strong className="font-monospace">{this.state.currentCrew.crewId}</strong>
													</div>
											</div>


										  <div className="row p-3">
													<div className="col-12 col-md-12">
														<div className="form-group">
														 <label htmlFor="inputInfo">{_GPY.i18n.get('gametype_SoccerFootball_crew_box_form_input_info_title')}</label>
														 <textarea value={this.state.currentCrew.info} ref="summaryContent" rows="5" name="info" onChange={(e) => {this.onChange(e,"info");}} className="form-control"></textarea>
														</div>
													</div>
												</div>


											<div className="row justify-content-end p-1">
													<div className="col-9 col-md-10 col-lg-10">

													</div>
													<div className="col-3 col-md-2 col-lg-2 text-right">
														  {this.state.unsave&&this.state.currentCrew._lastName?
																<button type="button" className="btn btn-success" onClick={()=>{this.createOrUpdateCrew()}}><span className={this.state.currentCrew.id>0?"glyphicon glyphicon-ok":"glyphicon glyphicon-plus"}/></button>
																:
																<button type="button" className="btn btn-primary disabled"><span className={this.state.currentCrew.id>0?"glyphicon glyphicon-ok":"glyphicon glyphicon-plus"}/></button>
															}

															{this.state.currentCrew.id>0?
																<button type="button" className="ml-2 btn btn-danger" onClick={()=>{this.deleteCrew()}}><span className="glyphicon glyphicon-remove"/></button>
															:
																<button type="button" className="ml-2 btn btn-danger disabled"><span className="glyphicon glyphicon-remove"/></button>
															}
													</div>
											</div>

									</div>


							 </div>
					</div>
					</div>
				);
	}

}
export default CrewSettings;
